export * from './ColorPaletteForm.ui';
